import axios from 'axios';
import { handleRequest } from 'api/util.api';

// configure(endpoint = "", auth = {}, defaultHeaders = {}) {
// this.endpoint = endpoint;
// this.auth = auth;
// this.defaultHeaders = defaultHeaders;
// this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

axios.create({
  baseURL: this.endpoint,
  timeout: 30000,
});

axios.interceptors.request.use((request) => {
  handleRequest(request);
  return request;
});

export default axios;



// WEBPACK FOOTER //
// src/store/services/axios.js